const modalTable = {
  render({ body, thead }): string {
    return body && thead
      ? `
      <table class="table">
        <thead class="thead">
          ${this.renderHead({ thead })}
        </thead>

        <tbody class="tbody">
          ${this.renderBody({ body })}
        </tbody>
      </table>
    `
      : ''
  },

  renderHead({ thead }): string {
    let html = '<tr class="tr">'

    thead.forEach((item) => {
      html += `
        <th class="th">${item}</th>
      `
    })

    html += '</tr>'

    return html
  },

  renderBody({ body }): string {
    let html = ''

    body.forEach((list) => {
      html += '<tr class="tr">'

      list.forEach((item) => {
        html += `
          <td class="td">
            <span class="body6">${item}</span>
          </td>
        `
      })

      html += '</tr>'
    })

    return html
  },
}

export default modalTable
